up.compiler(".up_invite_part", function (element) {
  function theCallback() {
    const elt = document.getElementById("add_participant");
    setTimeout(() => {
      elt.click();
    }, 50);
  }
  element.addEventListener("click", theCallback);
  return () => {
    element.removeEventListener("click", theCallback);
  };
});
